export default class DownloadButton {
  initializeListeners() {
    $('[data-download-button]').toArray().forEach(button => $(button).removeAttr('data-disable-with'));
  }
}
